import * as types from './types'

export const mutations = {
	[types.FETCH_NOTIFICATIONS] (state, { notifications }) {
		console.log(notifications)
		state.notifications = notifications
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/Notifications/mutations.js